import { render, staticRenderFns } from "./PaginationPanel5.vue?vue&type=template&id=1f9e2038&scoped=true"
import script from "./PaginationPanel5.vue?vue&type=script&lang=ts"
export * from "./PaginationPanel5.vue?vue&type=script&lang=ts"
import style0 from "./PaginationPanel5.vue?vue&type=style&index=0&id=1f9e2038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e2038",
  null
  
)

export default component.exports